import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  width: 200px;
  height: 150px;
  border: none;
  border-radius: 9px;
  background-color: rgba(0,0,0,1);
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  overflow:hidden;
  position: relative;
  flex-shrink: 0 ;

`;


const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  align-self:center; 
  border: none;
`;


const Inner01 = styled.div`
  display: flex;
  flex-start;
  flex-direction:column;

  height: auto;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;

`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.4em;
  letter-spacing: .6px;

  
`;


const ReusableInfoCard = (props) => {

  return(

  <Container>              

    <Inner01>
        
           <Tag>{props.tag}</Tag>
           
        <Description>{props.description}</Description>
  
    </Inner01>

   <Coverbg src= {props.coverbackground}/>
  </Container>

 );
}
export default ReusableInfoCard;